import { render, staticRenderFns } from "./BatchRefund.vue?vue&type=template&id=0fab1871&scoped=true&"
import script from "./BatchRefund.vue?vue&type=script&lang=js&"
export * from "./BatchRefund.vue?vue&type=script&lang=js&"
import style0 from "./BatchRefund.vue?vue&type=style&index=0&id=0fab1871&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab1871",
  null
  
)

export default component.exports